module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }